import React from 'react'
import prettysize from '../../../utils'
import { Popconfirm, Button, Icon, Progress } from 'antd'
import moment from 'moment'
import './styles.scss'

export default ({file, on_cancel}) => {
  const {currentFilename, rateAverageInKBperSecond, transferDirection, timeRemaining, percent} = file
  return (
    <div className='file-item columnWrap'>

      <div>
        <Icon type="file-text"/>
        <span>{ currentFilename ? currentFilename.replace(/^.*[\\\/]/, '') : null}</span>
      </div>

      <span>{transferDirection}</span>

      <span className='size'>{prettysize(rateAverageInKBperSecond * 1024) + '/s'}</span>

      <span>{moment.duration(timeRemaining/1000, "seconds").humanize(true)}</span>

      <div>
        <Progress percent={percent} status={'active'} />

        <Popconfirm title={'Are you sure to cancel ' + currentFilename + ' ?'} placement="top" okText="Yes" cancelText="No" onConfirm={()=> on_cancel(file)}>
          <Button icon="close" size={'small'}/>
        </Popconfirm>
      </div>
    </div>
  )
}
